import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Layout, Typography, Button } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import TramittaLogo from '../../images/tramitta-logo.png';
import LegalChileLogo from '../../images/legalchile.svg';
import YapoLogo from '../../images/yapo_logo.png';
import { EXTERNAL_URL } from '../../config/constants/urls';
import PropTypes from 'prop-types';

const { Header, Content } = Layout;
const { Title, Text } = Typography;

const CreationFail = ({ sourceUrl }) => {

  return (
    <React.Fragment key="payment-fail">
      <Header className="header-container">
        <Row className="header-logos mb-0">
          <img src={LegalChileLogo} alt="" className="legal-logo" />
          {sourceUrl === EXTERNAL_URL.YAPO &&
            <img src={YapoLogo} alt="" className="yapo-logo" />
          }
          <img src={TramittaLogo} alt="" className="tramitta-logo" />
        </Row>
      </Header>
      <Content className="ant-layout-content-custom">
        <Row className="mb-4">
          <Col md={12} className="text-center mx-auto">
            <CloseCircleOutlined style={{ fontSize: '64px', color: 'red' }} className="mb-4 mr-4" />
            <Title level={1}>¡Ups!</Title>
            <Text className="mb-2 fs-lg">Hubo un error contu proceso de pago, por favor vuelve a intentarlo</Text>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={16} className="text-center mx-auto">
            <Button className="px-4" size="large" type="primary">Volver al proceso de pago</Button>
          </Col>
        </Row>
      </Content>
    </React.Fragment>
  );
};

CreationFail.propTypes = {
  webpayData: PropTypes.object.isRequired,
  sourceUrl: PropTypes.string.isRequired,
};

const data = (state) => ({
  webpayData: state.webpay.webpayData,
  sourceUrl: state.contract.sourceUrl
});

export default connect(data, null)(CreationFail);